export const adminGetImpersonationLogs = "/admin/get_impersonation_logs";
